/** Textos dos pop-ups Teste, Criar Cliente e pickers. Fundido em messages.js. */

const ptBR = {
  'pw.steps': 'Etapas da criação',
  'pw.stepName': 'Etapa {n}: {name}',
  'pw.client': 'Cliente', 'pw.plan': 'Plano', 'pw.app': 'Aplicativo', 'pw.review': 'Revisão',
  'pw.progress': 'Etapa {n} de 4',
  'pw.progressCount': 'Etapa {n} de {count}',
  'pw.hint0': 'Identifique o cliente e escolha como entregar o acesso.',
  'pw.hint1': 'Escolha o plano, o conteúdo e as telas.',
  'pw.hint2': 'Escolha um aplicativo compatível com o aparelho.',
  'pw.hint3': 'Confira suas escolhas antes de criar o acesso.',
  'pw.cancel': 'Cancelar', 'pw.back': 'Voltar', 'pw.next': 'Continuar', 'pw.reviewAction': 'Revisar',
  'pw.reviewTitle': 'Tudo pronto para confirmar?',
  'pw.reviewHint': 'Nenhum acesso foi criado ainda. Você pode voltar e editar qualquer etapa.',
  'pw.edit': 'Editar', 'pw.editSection': 'Editar {name}',
  'pw.autoOn': 'Envio automático pelo WhatsApp ligado',
  'pw.autoOff': 'Envio manual pelo WhatsApp',
  'pw.autoOnHint': 'Após a criação, as orientações serão enviadas ao número informado acima.',
  'pw.autoOffHint': 'Após a criação, você poderá copiar a mensagem ou enviá-la manualmente.',
  'pw.intro': 'Preencha em etapas e confira o resumo antes de confirmar.',
  'pw.needApp': 'Escolha um aplicativo disponível ou Só Web Player / M3U.',
  'pw.selectedApp': 'Selecionado:', 'pw.notSelected': 'Nenhum aplicativo selecionado',
  'pw.planDuration': 'Conforme o plano escolhido', 'pw.price': 'Valor do plano',
  'pw.content': 'Conteúdo', 'pw.family': 'Familiar', 'pw.adult': 'Adulto incluso',
  'qt.title': 'Teste',
  'qt.desc':
    'Escolha um plano de teste e ajuste a duração. O conteúdo segue o pacote do servidor.',
  'qt.titleDone': 'Teste gerado',
  'qt.descDone': 'Acesso pronto — envie no WhatsApp ou copie o template.',
  'qt.done': 'Concluir',
  'qt.password': 'Senha',
  'qt.client': 'Cliente',
  'qt.screensLabel': 'Telas',
  'qt.clientName': 'Nome do cliente',
  'qt.clientNamePh': 'Ex: João da Silva',
  'qt.whatsapp': 'WhatsApp',
  'qt.whatsappPh': '+55 00 00000-0000',
  'qt.sendAuto': 'Enviar automaticamente no WhatsApp',
  'qt.sendAutoHint':
    'Após gerar o teste, a mensagem com usuário e senha vai direto para o número informado (via sua conexão WhatsApp).',
  'qt.duration': 'Duração do teste',
  'qt.screens': 'Telas / Conexões',
  'qt.screensMax': '(máx. {n})',
  'qt.screen1': '1 tela',
  'qt.screenN': '{n} telas',
  'qt.loadingCats': 'Carregando categorias…',
  'qt.loadingPlans': 'Carregando planos…',
  'qt.pickPlan': 'Conteúdo do teste',
  'qt.emptyPlans':
    'Nenhum plano com Teste ligado. Em IPTV → Planos, ligue o interruptor no cartão que a revenda deve usar.',
  'qt.generating': 'Gerando...',
  'qt.generate': 'Gerar teste de {dur}',
  'qt.generated': 'Teste gerado',
  'qt.username': 'Usuário',
  'qt.expires': 'Expira',
  'qt.waSent': 'Enviado no WhatsApp do cliente',
  'qt.copied': 'Copiado',
  'qt.copyTpl': 'Copiar template',
  'qt.alreadySent': 'Já enviado',
  'qt.sending': 'Enviando…',
  'qt.sendWa': 'Enviar no WhatsApp',
  'qt.newTest': 'Novo teste',
  'qt.needNameWa': 'Informe nome e WhatsApp',
  'qt.needCats': 'Selecione ao menos uma categoria',
  'qt.needPlan': 'Selecione um plano pronto',
  'qt.ok': 'Teste gerado com sucesso',
  'qt.fail': 'Falha ao gerar teste',
  'qt.tplCopied': 'Template copiado',
  'qt.copyFail': 'Não foi possível copiar',
  'qt.waNeed': 'Informe o WhatsApp para enviar',
  'qt.waOk': 'Mensagem enviada no WhatsApp',
  'qt.waFail': 'Falha ao enviar no WhatsApp',

  'cc.title': 'Criar cliente',
  'cc.titleDone': 'Cliente criado',
  'cc.desc':
    'Selecione o plano e preencha os dados do cliente. Conteúdo e duração seguem o pacote escolhido.',
  'cc.descDone': 'Acesso pronto — envie no WhatsApp ou copie o template.',
  'cc.clientName': 'Nome do cliente',
  'cc.clientNamePh': 'Ex: Ana Souza',
  'cc.whatsapp': 'WhatsApp',
  'cc.whatsappPh': '+55 00 00000-0000',
  'cc.sendAuto': 'Enviar automaticamente no WhatsApp',
  'cc.sendAutoHint':
    'Após criar o cliente, o template de acesso é enviado direto para o número informado (via sua conexão WhatsApp).',
  'cc.packageCats': 'Plano pronto',
  'cc.screens': 'Telas / Conexões',
  'cc.screensMax': '(até {n})',
  'cc.duration': 'Duração',
  'cc.client': 'Cliente',
  'cc.screensLabel': 'Telas',
  'cc.username': 'Usuário',
  'cc.password': 'Senha',
  'cc.expiry': 'Vencimento',
  'cc.waSent': 'Enviado no WhatsApp do cliente',
  'cc.copied': 'Copiado',
  'cc.copyTpl': 'Copiar template WhatsApp',
  'cc.alreadySent': 'Já enviado',
  'cc.sending': 'Enviando…',
  'cc.sendWa': 'Enviar no WhatsApp',
  'cc.new': 'Novo cadastro',
  'cc.done': 'Concluir',
  'cc.saving': 'Salvando...',
  'cc.create': 'Criar cliente',
  'cc.needNameWa': 'Informe nome e WhatsApp',
  'cc.needCats': 'Selecione ao menos uma categoria',
  'cc.needPlan': 'Selecione um plano pronto',
  'cc.emptyPlans': 'Nenhum plano no catálogo. Peça ao administrador para montar os templates em IPTV → Planos.',
  'cc.ok': 'Cliente criado com sucesso',
  'cc.fail': 'Falha ao criar cliente',
  'cc.tplCopied': 'Template copiado',
  'cc.copyFail': 'Não foi possível copiar',
  'cc.waNeed': 'Informe o WhatsApp para enviar',
  'cc.waOk': 'Mensagem enviada no WhatsApp',
  'cc.waFail': 'Falha ao enviar no WhatsApp',
  'cc.d15': '15 dias',
  'cc.d1m': '1 mês',
  'cc.d3m': '3 meses',
  'cc.d6m': '6 meses',
  'cc.d12m': '12 meses',
  'cc.d7': '7 dias',

  'aop.title': 'Formato de transmissão (saída de acesso)',
  'aop.hint': 'Define como o player recebe o sinal.',
  'aop.hintStrong': 'Recomendamos Ambos (HLS e MPEG-TS).',
  'aop.recommendedBadge': 'Recomendado',
  'aop.mpegtsSummary':
    'Libera somente MPEG-TS. Escolha quando o aplicativo exigir esse formato.',
  'aop.hlsSummary':
    'Libera somente HLS. Escolha quando o aplicativo exigir esse formato.',
  'aop.both': 'Ambos (HLS e MPEG-TS)',
  'aop.bothSummary':
    'Disponibiliza os dois formatos, conforme o pacote do servidor, para usar em diferentes aplicativos.',

  'plan.hours': '{n}h',
  'plan.day1': '1 dia',
  'plan.dayN': '{n} dias',
  'plan.month1': '1 mês',
  'plan.monthN': '{n} meses',
  'plan.min': '{n} min',
  'plan.badgeTest': 'Teste',
  'plan.credits': '{n} créd.',
  'plan.xuiPkg': 'Pacote do Servidor #{id}',
  'plan.loading': 'A carregar planos…',
  'plan.noneTitle': 'Nenhum plano pronto',
  'plan.noneHint':
    'O administrador monta os planos em IPTV → Planos. A revenda só clica nesta vitrine.',
  'plan.named': 'Plano de {dur} | {screens}',

  'cqp.label': 'Cliente em atendimento',
  'cqp.hint': 'Busque por nome ou WhatsApp, ou escolha alguém já em atendimento.',
  'cqp.searchPh': 'Buscar lead / cliente…',
  'cqp.searching': 'A procurar…',
  'cqp.empty': 'Nenhum contato encontrado. Digite o nome ou número.',
  'cqp.clear': 'Limpar',

  'gl.title': 'Gerar nova linha IPTV',
  'gl.desc': 'Escolha o plano pronto. Conteúdo e duração vêm do catálogo Office.',
  'gl.credFormat': 'Formato de geração aleatória',
  'gl.credGlobal': 'Regras globais ativas: o servidor ignora esta lista e usa',
  'gl.credLink': 'IPTV → Credenciais',
  'gl.numeric': 'Numérico — 0-9',
  'gl.alpha': 'Letras (minúsculas) — a-z',
  'gl.alphanumeric': 'Alfanumérico — a-z, 0-9',
  'gl.username': 'Usuário',
  'gl.password': 'Senha',
  'gl.userPh': 'Pelo menos 6 caracteres',
  'gl.passPh': 'Pelo menos 8 caracteres',
  'gl.genUser': 'Gerar usuário',
  'gl.genPass': 'Gerar senha',
  'gl.duration': 'Duração',
  'gl.screens': 'Telas',
  'gl.plan': 'Plano pronto',
  'gl.appTitle': 'Aplicativo do cliente *',
  'gl.appRequired': 'Obrigatório',
  'gl.appHint': 'Selecione o aplicativo que o cliente utilizará. A escolha será salva no acesso e incluída na mensagem enviada pelo WhatsApp.',
  'gl.needApp': 'Selecione o aplicativo do cliente antes de criar a linha.',
  'gl.linkContact': 'Vincular contato do CRM',
  'gl.linkContactHint': 'Pesquise por nome ou número',
  'gl.searchContact': 'Pesquisar contato…',
  'gl.selectContact': 'Selecione um contato',
  'gl.results': 'Resultados ({n})',
  'gl.clientName': 'Nome do cliente *',
  'gl.clientNamePh': 'Nome completo',
  'gl.whatsapp': 'WhatsApp *',
  'gl.whatsappPh': 'Ex: 5511999999999',
  'gl.notes': 'Notas internas',
  'gl.notesPh': 'Opcional',
  'gl.sendWa': 'Enviar credenciais automaticamente no WhatsApp',
  'gl.create': 'Criar linha',
  'gl.credentials': 'Credenciais',
  'gl.clientSection': 'Cliente',

  'catpick.label': 'Categorias liberadas',
  'catpick.live': 'Canais',
  'catpick.vod': 'Filmes',
  'catpick.series': 'Séries',
  'catpick.adult': '+18',
  'catpick.search': 'Buscar categoria… ex: futebol',
  'catpick.emptyFilter': 'Nenhuma categoria neste filtro. Sincronize o servidor em Categorias.',
  'catpick.noneSelected': 'Nenhuma categoria selecionada',
  'catpick.selectedN': '{n} categoria(s) selecionada(s)',

  'pwa.title': 'Instale o app',
  'pwa.simpleSubtitle': 'Tenha o {brand} na tela inicial do celular ou no computador.',
  'pwa.webApp': 'App web',
  'pwa.simpleBenefit': 'Acesse seu Office em uma janela própria, com o mesmo login e as mesmas funções.',
  'pwa.chooseDevice': 'Escolha o dispositivo para ver como instalar',
  'pwa.computer': 'Computador',
  'pwa.android': 'Android',
  'pwa.ios': 'iPhone / iPad',
  'pwa.guideDesktopTitle': 'Instalar no computador',
  'pwa.guideAndroidTitle': 'Instalar no Android',
  'pwa.guideIosTitle': 'Adicionar no iPhone ou iPad',
  'pwa.guideDesktop1': 'Abra este endereço no Google Chrome ou Microsoft Edge.',
  'pwa.guideDesktop2': 'Clique no ícone de instalação na barra de endereço ou procure “Instalar aplicativo” no menu do navegador.',
  'pwa.guideDesktop3': 'Confirme em “Instalar”. Depois, abra o {brand} pela lista de aplicativos do computador.',
  'pwa.guideAndroid1': 'Abra este endereço no Chrome do seu celular.',
  'pwa.guideAndroid2': 'Abra o menu ⋮ e toque em “Instalar aplicativo” ou “Adicionar à tela inicial”.',
  'pwa.guideAndroid3': 'Confirme a instalação. O ícone do {brand} ficará entre os seus aplicativos.',
  'pwa.guideIos1': 'Abra este endereço no Safari e toque em Compartilhar.',
  'pwa.guideIos2': 'Escolha “Adicionar à Tela de Início”. Se necessário, role a lista de opções.',
  'pwa.guideIos3': 'Ative “Abrir como App da Web”, se essa opção aparecer, e toque em “Adicionar”.',
  'pwa.nativeReady': 'A instalação automática está disponível neste dispositivo.',
  'pwa.installNow': 'Instalar agora',
  'pwa.manualFallback': 'Use as instruções acima para instalar pelo menu do navegador.',
  'pwa.cancelled': 'A instalação foi cancelada. Você ainda pode instalar pelo menu do navegador.',
  'pwa.reopenHint': 'Para abrir este guia novamente, use Atalhos → Instalar aplicativo.',
  'pwa.subtitle': 'Use o {brand} como aplicativo — ícone na tela inicial, sem barra do navegador.',
  'pwa.benefit1': 'Abre em janela própria no Windows, Android e iPhone.',
  'pwa.benefit2': 'Mais rápido no celular: atalho na tela inicial, sem digitar o site.',
  'pwa.benefit3': 'Avisos e atendimento continuam a funcionar no app instalado.',
  'pwa.how': 'Como instalar',
  'pwa.howIos': 'No iPhone / iPad (Safari)',
  'pwa.stepNative': 'Toque em Instalar para o navegador adicionar o app nesta conta.',
  'pwa.stepIos1': 'Toque em Compartilhar (□↑) na barra do Safari.',
  'pwa.stepIos2': 'Deslize e escolha «Adicionar à Tela de Início».',
  'pwa.stepIos3': 'Confirme — o ícone aparece na tela inicial como um app.',
  'pwa.stepAndroid1': 'No Chrome: menu ⋮ → «Instalar aplicativo» ou «Adicionar à tela inicial».',
  'pwa.stepAndroid2': 'Confirme — o ícone fica na gaveta / tela inicial.',
  'pwa.stepDesktop1': 'No Chrome ou Edge: ícone ⊕ / computador na barra de endereço.',
  'pwa.stepDesktop2': 'Ou menu ⋮ → «Instalar {brand}…» — abre como app no Windows.',
  'pwa.install': 'Instalar',
  'pwa.installing': 'A instalar…',
  'pwa.installBtn': 'Instalar aplicativo',
  'pwa.gotIt': 'Entendi',
  'pwa.later': 'Ocultar por 3 dias',
  'pwa.never': 'Não mostrar de novo',

  'update.versionTitle': 'Office v{version}',
  'update.versionDesc':
    'Versão {version} disponível. Recomendamos atualizar para ver as novidades.',
  'update.versionDescForce':
    'Versão {version} disponível. Atualize o painel para continuar com a versão mais recente.',
  'update.fallbackBody': 'Melhorias e correções nesta versão.',
  'update.later': 'Depois',
  'update.reloadNow': 'Atualizar agora',
  'update.announcementDesc': 'Comunicado da plataforma',
  'update.gotIt': 'Entendi',

  'releaseHistory.title': 'Histórico de atualizações',
  'releaseHistory.desc': 'Versões publicadas neste Office, com data e hora.',
  'releaseHistory.loading': 'A carregar histórico…',
  'releaseHistory.loadError': 'Não foi possível carregar o histórico.',
  'releaseHistory.retry': 'Tentar novamente',
  'releaseHistory.empty': 'Ainda não há versões registadas neste Office.',
  'releaseHistory.version': 'Office {version}',
  'releaseHistory.latest': 'Atual',
  'releaseHistory.close': 'Fechar',
};

const en = {
  'pw.steps': 'Creation steps',
  'pw.stepName': 'Step {n}: {name}',
  'pw.client': 'Customer', 'pw.plan': 'Plan', 'pw.app': 'App', 'pw.review': 'Review',
  'pw.progress': 'Step {n} of 4',
  'pw.progressCount': 'Step {n} of {count}',
  'pw.hint0': 'Identify the customer and choose how to deliver access.',
  'pw.hint1': 'Choose the plan, content and connections.',
  'pw.hint2': 'Choose an app compatible with the device.',
  'pw.hint3': 'Check your selections before creating access.',
  'pw.cancel': 'Cancel', 'pw.back': 'Back', 'pw.next': 'Continue', 'pw.reviewAction': 'Review',
  'pw.reviewTitle': 'Ready to confirm?',
  'pw.reviewHint': 'No access has been created yet. You can go back and edit any step.',
  'pw.edit': 'Edit', 'pw.editSection': 'Edit {name}',
  'pw.autoOn': 'Automatic WhatsApp delivery enabled',
  'pw.autoOff': 'Manual WhatsApp delivery',
  'pw.autoOnHint': 'After creation, instructions will be sent to the number shown above.',
  'pw.autoOffHint': 'After creation, you can copy the message or send it manually.',
  'pw.intro': 'Complete each step and review the summary before confirming.',
  'pw.needApp': 'Choose an available app or Web Player / M3U only.',
  'pw.selectedApp': 'Selected:', 'pw.notSelected': 'No app selected',
  'pw.planDuration': 'As specified by the selected plan', 'pw.price': 'Plan price',
  'pw.content': 'Content', 'pw.family': 'Family', 'pw.adult': 'Adult included',
  'qt.title': 'Quick Test',
  'qt.desc':
    'Click the trial plan. Content comes from the Servidor package — duration is chosen below. Only plans with Quick Test enabled appear here.',
  'qt.titleDone': 'Trial generated',
  'qt.descDone': 'Access ready — send on WhatsApp or copy the template.',
  'qt.done': 'Done',
  'qt.password': 'Password',
  'qt.client': 'Client',
  'qt.screensLabel': 'Screens',
  'qt.clientName': 'Client name',
  'qt.clientNamePh': 'E.g. John Smith',
  'qt.whatsapp': 'WhatsApp',
  'qt.whatsappPh': '+1 555 123-4567',
  'qt.sendAuto': 'Send automatically on WhatsApp',
  'qt.sendAutoHint':
    'After generating the trial, the message with username and password goes straight to the number provided (via your WhatsApp connection).',
  'qt.duration': 'Trial duration',
  'qt.screens': 'Screens / Connections',
  'qt.screensMax': '(max. {n})',
  'qt.screen1': '1 screen',
  'qt.screenN': '{n} screens',
  'qt.loadingCats': 'Loading categories…',
  'qt.loadingPlans': 'Loading plans…',
  'qt.pickPlan': 'Trial content',
  'qt.emptyPlans':
    'No plan with Quick Test on. In IPTV → Plans, turn on the switch on the card resellers should use.',
  'qt.generating': 'Generating...',
  'qt.generate': 'Generate {dur} trial',
  'qt.generated': 'Trial generated',
  'qt.username': 'Username',
  'qt.expires': 'Expires',
  'qt.waSent': 'Sent to the client’s WhatsApp',
  'qt.copied': 'Copied',
  'qt.copyTpl': 'Copy template',
  'qt.alreadySent': 'Already sent',
  'qt.sending': 'Sending…',
  'qt.sendWa': 'Send on WhatsApp',
  'qt.newTest': 'New trial',
  'qt.needNameWa': 'Enter name and WhatsApp',
  'qt.needCats': 'Select at least one category',
  'qt.needPlan': 'Select a ready-made plan',
  'qt.ok': 'Trial generated successfully',
  'qt.fail': 'Failed to generate trial',
  'qt.tplCopied': 'Template copied',
  'qt.copyFail': 'Could not copy',
  'qt.waNeed': 'Enter WhatsApp to send',
  'qt.waOk': 'Message sent on WhatsApp',
  'qt.waFail': 'Failed to send on WhatsApp',

  'cc.title': 'Create New Client',
  'cc.titleDone': 'Client created',
  'cc.desc':
    'Click a ready-made plan. Content, duration and WhatsApp template come from the Servidor package — duration is not chosen separately, and there is no extra bouquet on the panel.',
  'cc.descDone': 'Access ready — send on WhatsApp or copy the template.',
  'cc.clientName': 'Client name',
  'cc.clientNamePh': 'E.g. Jane Doe',
  'cc.whatsapp': 'WhatsApp',
  'cc.whatsappPh': '+1 555 123-4567',
  'cc.sendAuto': 'Send automatically on WhatsApp',
  'cc.sendAutoHint':
    'After creating the client, the access template is sent straight to the number provided (via your WhatsApp connection).',
  'cc.packageCats': 'Ready-made plan',
  'cc.screens': 'Screens / Connections',
  'cc.screensMax': '(up to {n})',
  'cc.duration': 'Duration',
  'cc.client': 'Client',
  'cc.screensLabel': 'Screens',
  'cc.username': 'Username',
  'cc.password': 'Password',
  'cc.expiry': 'Expiry',
  'cc.waSent': 'Sent to the client’s WhatsApp',
  'cc.copied': 'Copied',
  'cc.copyTpl': 'Copy WhatsApp template',
  'cc.alreadySent': 'Already sent',
  'cc.sending': 'Sending…',
  'cc.sendWa': 'Send on WhatsApp',
  'cc.new': 'New entry',
  'cc.done': 'Done',
  'cc.saving': 'Saving...',
  'cc.create': 'Create client',
  'cc.needNameWa': 'Enter name and WhatsApp',
  'cc.needCats': 'Select at least one category',
  'cc.needPlan': 'Select a ready-made plan',
  'cc.emptyPlans': 'No plans in the catalog. Ask the admin to set up templates under IPTV → Plans.',
  'cc.ok': 'Client created successfully',
  'cc.fail': 'Failed to create client',
  'cc.tplCopied': 'Template copied',
  'cc.copyFail': 'Could not copy',
  'cc.waNeed': 'Enter WhatsApp to send',
  'cc.waOk': 'Message sent on WhatsApp',
  'cc.waFail': 'Failed to send on WhatsApp',
  'cc.d15': '15 days',
  'cc.d1m': '1 month',
  'cc.d3m': '3 months',
  'cc.d6m': '6 months',
  'cc.d12m': '12 months',
  'cc.d7': '7 days',

  'aop.title': 'Stream format (Access Output)',
  'aop.hint': 'Defines how the player receives the signal.',
  'aop.hintStrong': 'We recommend Both (HLS and MPEG-TS).',
  'aop.recommendedBadge': 'Recommended',
  'aop.mpegtsSummary':
    'Enables only MPEG-TS. Choose when the app requires this format.',
  'aop.hlsSummary':
    'Enables only HLS. Choose when the app requires this format.',
  'aop.both': 'Both (HLS and MPEG-TS)',
  'aop.bothSummary':
    'Enables both formats supported by the server package for use across different apps.',

  'plan.hours': '{n}h',
  'plan.day1': '1 day',
  'plan.dayN': '{n} days',
  'plan.month1': '1 month',
  'plan.monthN': '{n} months',
  'plan.min': '{n} min',
  'plan.badgeTest': 'Trial',
  'plan.credits': '{n} cr.',
  'plan.xuiPkg': 'Servidor package #{id}',
  'plan.loading': 'Loading plans…',
  'plan.noneTitle': 'No ready-made plans',
  'plan.noneHint':
    'The administrator builds plans in IPTV → Plans. Resellers just click this showcase.',
  'plan.named': '{dur} plan | {screens}',

  'cqp.label': 'Client in service',
  'cqp.hint': 'Search by name or WhatsApp, or pick someone already in a conversation.',
  'cqp.searchPh': 'Search lead / client…',
  'cqp.searching': 'Searching…',
  'cqp.empty': 'No contact found. Type a name or number.',
  'cqp.clear': 'Clear',

  'gl.title': 'Generate new IPTV line',
  'gl.desc': 'Pick a ready-made plan. Content and duration come from the Office catalog.',
  'gl.credFormat': 'Random credential format',
  'gl.credGlobal': 'Global rules active: the server ignores this list and uses',
  'gl.credLink': 'IPTV → Credentials',
  'gl.numeric': 'Numeric — 0-9',
  'gl.alpha': 'Lowercase letters — a-z',
  'gl.alphanumeric': 'Alphanumeric — a-z, 0-9',
  'gl.username': 'Username',
  'gl.password': 'Password',
  'gl.userPh': 'At least 6 characters',
  'gl.passPh': 'At least 8 characters',
  'gl.genUser': 'Generate username',
  'gl.genPass': 'Generate password',
  'gl.duration': 'Duration',
  'gl.screens': 'Screens',
  'gl.plan': 'Ready-made plan',
  'gl.appTitle': 'Client application *',
  'gl.appRequired': 'Required',
  'gl.appHint': 'Select the application the client will use. The choice will be saved with the access and included in the WhatsApp message.',
  'gl.needApp': 'Select the client application before creating the line.',
  'gl.linkContact': 'Link CRM contact',
  'gl.linkContactHint': 'Search by name or number',
  'gl.searchContact': 'Search contact…',
  'gl.selectContact': 'Select a contact',
  'gl.results': 'Results ({n})',
  'gl.clientName': 'Client name *',
  'gl.clientNamePh': 'Full name',
  'gl.whatsapp': 'WhatsApp *',
  'gl.whatsappPh': 'E.g. 15551234567',
  'gl.notes': 'Internal notes',
  'gl.notesPh': 'Optional',
  'gl.sendWa': 'Send credentials automatically on WhatsApp',
  'gl.create': 'Create line',
  'gl.credentials': 'Credentials',
  'gl.clientSection': 'Client',

  'catpick.label': 'Enabled categories',
  'catpick.live': 'Channels',
  'catpick.vod': 'Movies',
  'catpick.series': 'Series',
  'catpick.adult': '+18',
  'catpick.search': 'Search category… e.g. soccer',
  'catpick.emptyFilter': 'No categories in this filter. Sync the server under Categories.',
  'catpick.noneSelected': 'No category selected',
  'catpick.selectedN': '{n} categor(y/ies) selected',

  'pwa.title': 'Install the app',
  'pwa.subtitle': 'Use {brand} as an app — home-screen icon, no browser chrome.',
  'pwa.benefit1': 'Opens in its own window on Windows, Android and iPhone.',
  'pwa.benefit2': 'Faster on mobile: home-screen shortcut, no typing the URL.',
  'pwa.benefit3': 'Alerts and inbox keep working in the installed app.',
  'pwa.how': 'How to install',
  'pwa.howIos': 'On iPhone / iPad (Safari)',
  'pwa.stepNative': 'Tap Install and the browser will add the app for this account.',
  'pwa.stepIos1': 'Tap Share (□↑) in the Safari toolbar.',
  'pwa.stepIos2': 'Scroll and choose «Add to Home Screen».',
  'pwa.stepIos3': 'Confirm — the icon appears on the home screen like an app.',
  'pwa.stepAndroid1': 'In Chrome: menu ⋮ → «Install app» or «Add to Home screen».',
  'pwa.stepAndroid2': 'Confirm — the icon lands on the home screen / app drawer.',
  'pwa.stepDesktop1': 'In Chrome or Edge: ⊕ / monitor icon in the address bar.',
  'pwa.stepDesktop2': 'Or menu ⋮ → «Install {brand}…» — opens as a Windows app.',
  'pwa.install': 'Install',
  'pwa.installing': 'Installing…',
  'pwa.installBtn': 'Install app',
  'pwa.gotIt': 'Got it',
  'pwa.later': 'Hide for 3 days',
  'pwa.never': 'Don’t show again',

  'update.versionTitle': 'Office v{version}',
  'update.versionDesc':
    'Version {version} is available. We recommend updating to see what’s new.',
  'update.versionDescForce':
    'Version {version} is available. Update the panel to continue on the latest release.',
  'update.fallbackBody': 'Improvements and fixes in this version.',
  'update.later': 'Later',
  'update.reloadNow': 'Update now',
  'update.announcementDesc': 'Platform announcement',
  'update.gotIt': 'Got it',

  'releaseHistory.title': 'Update history',
  'releaseHistory.desc': 'Versions published in this Office, with date and time.',
  'releaseHistory.loading': 'Loading history…',
  'releaseHistory.loadError': 'Could not load the history.',
  'releaseHistory.retry': 'Try again',
  'releaseHistory.empty': 'No versions recorded in this Office yet.',
  'releaseHistory.version': 'Office {version}',
  'releaseHistory.latest': 'Current',
  'releaseHistory.close': 'Close',
};

const es = {
  'pw.steps': 'Pasos de creación',
  'pw.stepName': 'Paso {n}: {name}',
  'pw.client': 'Cliente', 'pw.plan': 'Plan', 'pw.app': 'Aplicación', 'pw.review': 'Revisión',
  'pw.progress': 'Paso {n} de 4',
  'pw.progressCount': 'Paso {n} de {count}',
  'pw.hint0': 'Identifica al cliente y elige cómo entregar el acceso.',
  'pw.hint1': 'Elige el plan, el contenido y las conexiones.',
  'pw.hint2': 'Elige una aplicación compatible con el dispositivo.',
  'pw.hint3': 'Revisa tus selecciones antes de crear el acceso.',
  'pw.cancel': 'Cancelar', 'pw.back': 'Volver', 'pw.next': 'Continuar', 'pw.reviewAction': 'Revisar',
  'pw.reviewTitle': '¿Todo listo para confirmar?',
  'pw.reviewHint': 'Aún no se ha creado ningún acceso. Puedes volver y editar cualquier paso.',
  'pw.edit': 'Editar', 'pw.editSection': 'Editar {name}',
  'pw.autoOn': 'Envío automático por WhatsApp activado',
  'pw.autoOff': 'Envío manual por WhatsApp',
  'pw.autoOnHint': 'Después de crear, las instrucciones se enviarán al número indicado arriba.',
  'pw.autoOffHint': 'Después de crear, podrás copiar el mensaje o enviarlo manualmente.',
  'pw.intro': 'Completa los pasos y revisa el resumen antes de confirmar.',
  'pw.needApp': 'Elige una aplicación disponible o Solo Web Player / M3U.',
  'pw.selectedApp': 'Seleccionado:', 'pw.notSelected': 'Ninguna aplicación seleccionada',
  'pw.planDuration': 'Según el plan elegido', 'pw.price': 'Precio del plan',
  'pw.content': 'Contenido', 'pw.family': 'Familiar', 'pw.adult': 'Adulto incluido',
  'qt.title': 'Prueba rápida',
  'qt.desc':
    'Pulsa el plan de prueba. El contenido ya viene del paquete Servidor — la duración se elige abajo. Solo entran planes con «Prueba rápida» activada.',
  'qt.titleDone': 'Prueba generada',
  'qt.descDone': 'Acceso listo — envía por WhatsApp o copia la plantilla.',
  'qt.done': 'Concluir',
  'qt.password': 'Contraseña',
  'qt.client': 'Cliente',
  'qt.screensLabel': 'Pantallas',
  'qt.clientName': 'Nombre del cliente',
  'qt.clientNamePh': 'Ej: Juan Pérez',
  'qt.whatsapp': 'WhatsApp',
  'qt.whatsappPh': '+34 600 123 456',
  'qt.sendAuto': 'Enviar automáticamente por WhatsApp',
  'qt.sendAutoHint':
    'Tras generar la prueba, el mensaje con usuario y contraseña va directo al número indicado (vía tu conexión WhatsApp).',
  'qt.duration': 'Duración de la prueba',
  'qt.screens': 'Pantallas / Conexiones',
  'qt.screensMax': '(máx. {n})',
  'qt.screen1': '1 pantalla',
  'qt.screenN': '{n} pantallas',
  'qt.loadingCats': 'Cargando categorías…',
  'qt.loadingPlans': 'Cargando planes…',
  'qt.pickPlan': 'Contenido de la prueba',
  'qt.emptyPlans':
    'Ningún plan con Prueba rápida activada. En el catálogo, enciende el interruptor en la tarjeta que debe usar la red.',
  'qt.generating': 'Generando...',
  'qt.generate': 'Generar prueba de {dur}',
  'qt.generated': 'Prueba generada',
  'qt.username': 'Usuario',
  'qt.expires': 'Expira',
  'qt.waSent': 'Enviado al WhatsApp del cliente',
  'qt.copied': 'Copiado',
  'qt.copyTpl': 'Copiar plantilla',
  'qt.alreadySent': 'Ya enviado',
  'qt.sending': 'Enviando…',
  'qt.sendWa': 'Enviar por WhatsApp',
  'qt.newTest': 'Nueva prueba',
  'qt.needNameWa': 'Indica nombre y WhatsApp',
  'qt.needCats': 'Selecciona al menos una categoría',
  'qt.needPlan': 'Selecciona un plan listo',
  'qt.ok': 'Prueba generada con éxito',
  'qt.fail': 'Error al generar la prueba',
  'qt.tplCopied': 'Plantilla copiada',
  'qt.copyFail': 'No se pudo copiar',
  'qt.waNeed': 'Indica el WhatsApp para enviar',
  'qt.waOk': 'Mensaje enviado por WhatsApp',
  'qt.waFail': 'Error al enviar por WhatsApp',

  'cc.title': 'Crear nuevo cliente',
  'cc.titleDone': 'Cliente creado',
  'cc.desc':
    'Haz clic en el plan listo. Contenido, duración y plantilla de WhatsApp vienen del paquete Servidor — sin elegir duración aparte y sin bouquet extra en el panel.',
  'cc.descDone': 'Acceso listo — envía por WhatsApp o copia la plantilla.',
  'cc.clientName': 'Nombre del cliente',
  'cc.clientNamePh': 'Ej: Ana López',
  'cc.whatsapp': 'WhatsApp',
  'cc.whatsappPh': '+34 600 123 456',
  'cc.sendAuto': 'Enviar automáticamente por WhatsApp',
  'cc.sendAutoHint':
    'Tras crear el cliente, la plantilla de acceso se envía directo al número indicado (vía tu conexión WhatsApp).',
  'cc.packageCats': 'Plan listo',
  'cc.screens': 'Pantallas / Conexiones',
  'cc.screensMax': '(hasta {n})',
  'cc.duration': 'Duración',
  'cc.client': 'Cliente',
  'cc.screensLabel': 'Pantallas',
  'cc.username': 'Usuario',
  'cc.password': 'Contraseña',
  'cc.expiry': 'Vencimiento',
  'cc.waSent': 'Enviado al WhatsApp del cliente',
  'cc.copied': 'Copiado',
  'cc.copyTpl': 'Copiar plantilla WhatsApp',
  'cc.alreadySent': 'Ya enviado',
  'cc.sending': 'Enviando…',
  'cc.sendWa': 'Enviar por WhatsApp',
  'cc.new': 'Nuevo registro',
  'cc.done': 'Listo',
  'cc.saving': 'Guardando...',
  'cc.create': 'Crear cliente',
  'cc.needNameWa': 'Indica nombre y WhatsApp',
  'cc.needCats': 'Selecciona al menos una categoría',
  'cc.needPlan': 'Selecciona un plan listo',
  'cc.emptyPlans': 'No hay planes en el catálogo. Pide al administrador que monte las plantillas en IPTV → Planes.',
  'cc.ok': 'Cliente creado con éxito',
  'cc.fail': 'Error al crear el cliente',
  'cc.tplCopied': 'Plantilla copiada',
  'cc.copyFail': 'No se pudo copiar',
  'cc.waNeed': 'Indica el WhatsApp para enviar',
  'cc.waOk': 'Mensaje enviado por WhatsApp',
  'cc.waFail': 'Error al enviar por WhatsApp',
  'cc.d15': '15 días',
  'cc.d1m': '1 mes',
  'cc.d3m': '3 meses',
  'cc.d6m': '6 meses',
  'cc.d12m': '12 meses',
  'cc.d7': '7 días',

  'aop.title': 'Formato de transmisión (salida de acceso)',
  'aop.hint': 'Define cómo el player recibe la señal.',
  'aop.hintStrong': 'Recomendamos Ambos (HLS y MPEG-TS).',
  'aop.recommendedBadge': 'Recomendado',
  'aop.mpegtsSummary':
    'Habilita solo MPEG-TS. Elige esta opción si la aplicación requiere ese formato.',
  'aop.hlsSummary':
    'Habilita solo HLS. Elige esta opción si la aplicación requiere ese formato.',
  'aop.both': 'Ambos (HLS y MPEG-TS)',
  'aop.bothSummary':
    'Habilita ambos formatos compatibles con el paquete del servidor para usar diferentes aplicaciones.',

  'plan.hours': '{n}h',
  'plan.day1': '1 día',
  'plan.dayN': '{n} días',
  'plan.month1': '1 mes',
  'plan.monthN': '{n} meses',
  'plan.min': '{n} min',
  'plan.badgeTest': 'Prueba',
  'plan.credits': '{n} créd.',
  'plan.xuiPkg': 'Paquete Servidor #{id}',
  'plan.loading': 'Cargando planes…',
  'plan.noneTitle': 'Ningún plan listo',
  'plan.noneHint':
    'El administrador monta los planes en IPTV → Planes. La reventa solo pulsa esta vitrina.',
  'plan.named': 'Plan de {dur} | {screens}',

  'cqp.label': 'Cliente en atención',
  'cqp.hint': 'Busca por nombre o WhatsApp, o elige a alguien ya en conversación.',
  'cqp.searchPh': 'Buscar lead / cliente…',
  'cqp.searching': 'Buscando…',
  'cqp.empty': 'Ningún contacto encontrado. Escribe el nombre o número.',
  'cqp.clear': 'Limpiar',

  'gl.title': 'Generar nueva línea IPTV',
  'gl.desc': 'Elige el plan listo. Contenido y duración vienen del catálogo Office.',
  'gl.credFormat': 'Formato de generación aleatoria',
  'gl.credGlobal': 'Reglas globales activas: el servidor ignora esta lista y usa',
  'gl.credLink': 'IPTV → Credenciales',
  'gl.numeric': 'Numérico — 0-9',
  'gl.alpha': 'Letras (minúsculas) — a-z',
  'gl.alphanumeric': 'Alfanumérico — a-z, 0-9',
  'gl.username': 'Usuario',
  'gl.password': 'Contraseña',
  'gl.userPh': 'Al menos 6 caracteres',
  'gl.passPh': 'Al menos 8 caracteres',
  'gl.genUser': 'Generar usuario',
  'gl.genPass': 'Generar contraseña',
  'gl.duration': 'Duración',
  'gl.screens': 'Pantallas',
  'gl.plan': 'Plan listo',
  'gl.appTitle': 'Aplicación del cliente *',
  'gl.appRequired': 'Obligatorio',
  'gl.appHint': 'Selecciona la aplicación que utilizará el cliente. La elección se guardará en el acceso y se incluirá en el mensaje de WhatsApp.',
  'gl.needApp': 'Selecciona la aplicación del cliente antes de crear la línea.',
  'gl.linkContact': 'Vincular contacto del CRM',
  'gl.linkContactHint': 'Busca por nombre o número',
  'gl.searchContact': 'Buscar contacto…',
  'gl.selectContact': 'Selecciona un contacto',
  'gl.results': 'Resultados ({n})',
  'gl.clientName': 'Nombre del cliente *',
  'gl.clientNamePh': 'Nombre completo',
  'gl.whatsapp': 'WhatsApp *',
  'gl.whatsappPh': 'Ej: 5491123456789',
  'gl.notes': 'Notas internas',
  'gl.notesPh': 'Opcional',
  'gl.sendWa': 'Enviar credenciales automáticamente por WhatsApp',
  'gl.create': 'Crear línea',
  'gl.credentials': 'Credenciales',
  'gl.clientSection': 'Cliente',

  'catpick.label': 'Categorías liberadas',
  'catpick.live': 'Canales',
  'catpick.vod': 'Películas',
  'catpick.series': 'Series',
  'catpick.adult': '+18',
  'catpick.search': 'Buscar categoría… ej: fútbol',
  'catpick.emptyFilter': 'Ninguna categoría en este filtro. Sincroniza el servidor en Categorías.',
  'catpick.noneSelected': 'Ninguna categoría seleccionada',
  'catpick.selectedN': '{n} categoría(s) seleccionada(s)',

  'pwa.title': 'Instala la app',
  'pwa.subtitle': 'Usa {brand} como aplicación — icono en inicio, sin barra del navegador.',
  'pwa.benefit1': 'Se abre en ventana propia en Windows, Android e iPhone.',
  'pwa.benefit2': 'Más rápido en el móvil: acceso en la pantalla de inicio.',
  'pwa.benefit3': 'Avisos y atención siguen funcionando en la app instalada.',
  'pwa.how': 'Cómo instalar',
  'pwa.howIos': 'En iPhone / iPad (Safari)',
  'pwa.stepNative': 'Pulsa Instalar para que el navegador añada la app en esta cuenta.',
  'pwa.stepIos1': 'Pulsa Compartir (□↑) en la barra de Safari.',
  'pwa.stepIos2': 'Elige «Añadir a pantalla de inicio».',
  'pwa.stepIos3': 'Confirma — el icono aparece en inicio como una app.',
  'pwa.stepAndroid1': 'En Chrome: menú ⋮ → «Instalar aplicación» o «Añadir a pantalla de inicio».',
  'pwa.stepAndroid2': 'Confirma — el icono queda en inicio / cajón de apps.',
  'pwa.stepDesktop1': 'En Chrome o Edge: icono ⊕ / monitor en la barra de dirección.',
  'pwa.stepDesktop2': 'O menú ⋮ → «Instalar {brand}…» — se abre como app en Windows.',
  'pwa.install': 'Instalar',
  'pwa.installing': 'Instalando…',
  'pwa.installBtn': 'Instalar aplicación',
  'pwa.gotIt': 'Entendido',
  'pwa.later': 'Ocultar 3 días',
  'pwa.never': 'No mostrar de nuevo',

  'update.versionTitle': 'Office v{version}',
  'update.versionDesc':
    'Versión {version} disponible. Te recomendamos actualizar para ver las novedades.',
  'update.versionDescForce':
    'Versión {version} disponible. Actualiza el panel para continuar con la versión más reciente.',
  'update.fallbackBody': 'Mejoras y correcciones en esta versión.',
  'update.later': 'Después',
  'update.reloadNow': 'Actualizar ahora',
  'update.announcementDesc': 'Comunicado de la plataforma',
  'update.gotIt': 'Entendido',

  'releaseHistory.title': 'Historial de actualizaciones',
  'releaseHistory.desc': 'Versiones publicadas en este Office, con fecha y hora.',
  'releaseHistory.loading': 'Cargando historial…',
  'releaseHistory.loadError': 'No se pudo cargar el historial.',
  'releaseHistory.retry': 'Reintentar',
  'releaseHistory.empty': 'Aún no hay versiones registradas en este Office.',
  'releaseHistory.version': 'Office {version}',
  'releaseHistory.latest': 'Actual',
  'releaseHistory.close': 'Cerrar',
};

export const MODAL_MESSAGES = {
  'pt-BR': ptBR,
  en,
  es,
};
